import React, { useEffect, useState, useLayoutEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { ICalendar } from '@schemas/video';
import { parseTime, sendShow } from '@/utils/helpers';

interface ICanlendarCardProps {
  index: number;
  live: ICalendar;
}

const CalendarCard = ({ index, live }) => {
  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true
  });

  useEffect(() => {
    if (inView) {
      sendShow('CALENDAR_LIST', {
        calendar_id: live.id,
        button_name: live.liveState === 0 ? 'LIVE' : 'APPOINTMENT',
        index: index + 1
      });
    }
  }, [inView]);

  const handleTime = (time: string | undefined, type: number) => {
    if (!time) return null;
    const dateStrOfToday = parseTime(new Date(), '{y}-{m}-{d}');
    const dateStrOfTomorrow = parseTime(
      Date.now() + 24 * 60 * 60 * 1000,
      '{y}-{m}-{d}'
    );
    const inputDate = parseTime(time, '{y}-{m}-{d}');
    if (inputDate === dateStrOfToday && type === 2) {
      return '今日';
    }
    if (inputDate === dateStrOfTomorrow && type === 2) {
      return '明日';
    }

    let inputTime = time;
    if (inputTime.includes('-')) {
      inputTime = time.replace(/\.|-/g, '/');
    }
    const nowTime = new Date(inputTime);
    const formatObj = {
      m: nowTime.getMonth() + 1,
      d: nowTime.getDate(),
      h: nowTime.getHours(),
      i: nowTime.getMinutes()
    };
    const formatTime = {
      h: formatObj.h < 10 ? `0${formatObj.h}` : `${formatObj.h}`,
      i: formatObj.i < 10 ? `0${formatObj.i}` : `${formatObj.i}`
    };
    if (type === 1) {
      return `${formatTime.h}:${formatTime.i}`;
    }
    return `${formatObj.m}月${formatObj.d}日`;
  };

  return (
    <li className="live-info" key={index} ref={ref}>
      <div className="time">
        <h1>{handleTime(live.startTime, 1)}</h1>
        <h3>{handleTime(live.startTime, 2)}</h3>
      </div>
      <div className="intro">
        <p>{live.liveTheme}</p>
        {/* {live.status ? (
        <div className="status-on">
          <img src={IconLiveOn} alt="" />
          <h3>直播中</h3>
        </div>
      ) : (
        <div className="status-off">
          <span className="iconfont icon-play" />
          <h3>预约直播</h3>
        </div>
      )} */}
      </div>
    </li>
  );
};

export default CalendarCard;
